// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { HtmlContent } from "../../../data/app-core/html-content";
import { EnvelopeDocument } from "../base/envelope-document";

export class HtmlContentDocument extends EnvelopeDocument {
	public override Item: HtmlContent = new HtmlContent();
}